module.exports = __webpack_public_path__ + "static/media/game-background-memory.cc51cac6.jpg";